import { Link } from "react-router-dom"
import { useAuth } from "../context/AuthContext"
import { usePartnerMode } from "../hooks/usePartnerMode"
import '../header.css'

const AppHeader = () => {
  const { profile } = useAuth()
  const { loading: partnerLoading, isPartnerMode } = usePartnerMode()

  // Afficher "Mon compte" uniquement si connecté, pas en chargement, et pas en mode partenaire
  const showAccountLink = !!profile?.role && !partnerLoading && !isPartnerMode

  return (
    <header className="app-header-premium">
      <div className="header-container">
        <div className="header-logo">
          <Link to="/" className="logo-link">
            <span className="logo-text">StringNow</span>
            <span className="logo-subtitle">Crissier · Lausanne</span>
          </Link>
        </div>

        <nav className="header-nav">
          <Link className="nav-link" to="/order/start">
            Réserver
          </Link>

          
          {showAccountLink && (
            <Link className="nav-link nav-link-icon" to="/account" title="Mon compte">
              <svg className="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </Link>
          )}
          
          {!profile?.role && (
            <Link to="/auth/login" className="nav-link nav-link-login">
              Se connecter
            </Link>
          )}
          
          {profile?.role === "ADMIN" && (
            <Link className="nav-link nav-link-admin" to="/admin">
              Admin
            </Link>
          )}
        </nav>
      </div>
    </header>
  )
}

export default AppHeader
